/** First-login getting-started guide: a welcome popup, then a small card that walks through four pages. */
export const tour = {
  menu: "Getting started",
  label: "Getting started guide",
  welcomeTitle: "Welcome to iCryptoNow, {name}",
  welcomeBody: "Four short steps show you around. Each one opens the right page and tells you what to do there. It takes about five minutes.",
  start: "Start step 1",
  later: "Later",
  stepOf: "Step {n} of {total}",
  goThere: "Open this page",
  next: "Next step",
  back: "Back",
  finish: "Finish",
  close: "Close guide",
  reopenHint: "Open this guide again any time from “How-to guide” in the left menu, or click your name at the top right, then “Getting started”.",

  steps: {
    networks: {
      title: "Turn on a network",
      body: "In Vault, pick the coin and network you want to receive (USDT on BNB Chain, also called BEP20, is the most common) and enter your own wallet as the vault owner. The vault is where payout money is kept, and only your wallet controls it.",
    },
    invite: {
      title: "Invite your team",
      body: "Click “Invite member” and choose a role for each person: Finance can send and approve payouts, Viewer can only look. Send them the link privately; it works once and expires in 72 hours.",
    },
    telegram: {
      title: "Approve payouts from your phone",
      body: "Under Telegram approval, link your Telegram. Large payouts then reach you as a message you approve or reject with two taps.",
    },
    developers: {
      title: "Connect your website",
      body: "Hand this page to your developer. They create an API key and set the webhook URL, so player deposits and payouts run automatically.",
    },
    overview: {
      title: "Your money at a glance",
      body: "The Overview shows how much money is available, today's deposits and payouts, and any payouts waiting for approval.",
    },
    deposits: {
      title: "Check a player's deposit",
      body: "When a player says their money hasn't arrived, ask for their player ID or the transaction ID and type it into the search box at the top of the page. You'll see whether it arrived.",
    },
    approve: {
      title: "Approve large payouts",
      body: "Open the “Waiting for approval” tab. Check the wallet address and the amount, then approve or reject. You can't approve a payout you created yourself.",
    },
    payouts: {
      title: "Track payouts",
      body: "Every payout to a player and its status is listed here. Open one to see the details and its transaction ID.",
    },
    statement: {
      title: "Reconcile your balance",
      body: "Statement works like a bank statement: every deposit credited and every payout sent, with the balance after each one. You can export it as a spreadsheet.",
    },
    security: {
      title: "Keep your account safe",
      body: "Logging in needs your password plus the 6-digit code from your phone. Never give either to anyone, including iCryptoNow staff. Here you can also see every device logged in to your account.",
    },
  },
};
